import React from 'react';
import TextField from '@material-ui/core/TextField';
import { debounce } from 'lodash';
import classnames from 'classnames';
import { FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { createFilterOptions } from '@material-ui/lab/Autocomplete';
import { FbAutocompleteSelect } from '../../../components/FbAutocompleteSelect';
import { interactiveFilterStyle } from './interactiveFilterStyle';

// eslint-disable-next-line no-unused-vars
const useStyles = makeStyles(theme => interactiveFilterStyle);

const filterOptions = createFilterOptions({
  stringify: option => option?.name + option?.slug,
});

export function newInteractiveFilter(filterType, getOptions) {
  // eslint-disable-next-line no-unused-vars
  return function InteractiveFilter({
    options,
    aggregationQuery,
    onSelectValue,
    onClearValue,
    label,
    // eslint-disable-next-line no-unused-vars
    ...additionalProps
  }) {
    const classes = useStyles();
    const { value, onSearch, isMobile, ...restOfTheProps } = additionalProps;

    const props = {
      'data-test-id': `${filterType}-filter`,
      onOpen: (event, setOptionsCallback) => {
        getOptions({
          endpoint: aggregationQuery.endpoint,
          query: aggregationQuery.query,
        }).then(data => {
          setOptionsCallback({
            options: data.data,
          });
        });
      },
      // eslint-disable-next-line no-shadow
      onChange: (event, selectedValue, reason) => {
        if (reason === 'select-option') {
          onSelectValue(filterType, selectedValue);
        }
        if (reason === 'clear') {
          onClearValue(filterType, reason);
        }
      },
      onFocus: (event, setOptionsCallback) => {
        const keyword = event.target.value || '';
        const { endpoint, query } = aggregationQuery;
        const { aggregation_type, aggregation_query, ...addtionalFilters } = query;
        getOptions({
          endpoint,
          query: {
            aggregation_type: filterType,
            aggregation_query: keyword?.toLowerCase(),
            ...addtionalFilters,
          },
        }).then(data => {
          setOptionsCallback({
            options: data.data,
          });
        });
      },
      onSearch: debounce((keyword, setOptionsCallback) => {
        const { endpoint, query } = aggregationQuery;
        const { aggregation_type, aggregation_query, ...addtionalFilters } = query;
        getOptions({
          endpoint,
          query: {
            aggregation_type: filterType,
            aggregation_query: keyword?.toLowerCase(),
            ...addtionalFilters,
          },
        }).then(data => {
          setOptionsCallback({
            options: data.data,
          });
        });
        onSearch && onSearch(keyword?.toLowerCase());
      }, 100),
      getOptionSelected: (option, optionValue) => {
        return option.name === optionValue?.name;
      },
      getOptionLabel: option => option?.name,
      options,
      loading: false,
      forcePopupIcon: false,
      disablePortal: false,
      openOnFocus: true,
      selectOnFocus: true,
      debug: true,
      value,
      filterOptions,
      ...restOfTheProps,
      renderInput: params => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          InputProps={{
            ...params.InputProps,
          }}
          // eslint-disable-next-line react/jsx-no-duplicate-props
          inputProps={{
            ...params.inputProps,
            autoComplete: 'nope',
          }}
        />
      ),
    };
    return (
      <FormControl fullWidth className={classnames(classes.field)}>
        <FbAutocompleteSelect
          {...props}
          classes={{
            root: classes.root,
            inputRoot: classes.inputRoot,
            clearIndicator: classes.clearIndicator,
            popper: isMobile ? classes.popper : classnames(classes.popper, classes.popperDesktop),
            option: classes.option,
          }}
        />
      </FormControl>
    );
  };
}
